<template>
  <v-menu
    v-model="menu"
    ref="userMenu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
    offset-y>

    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon color="black">mdi-account-outline</v-icon>
      </v-btn>
    </template>
    <v-card style="width:300px">
      <v-list>
        <v-list-item>
          <v-list-item-title>ユーザー情報</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>健康保険 記号ー番号</v-list-item-subtitle>
            <v-list-item-title>{{this.userviewInfo.certificate_number}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>利用者区分</v-list-item-subtitle>
            <v-list-item-title>{{this.userviewInfo.user_classification}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="this.userviewInfo.user_classification === '本人'">
          <v-list-item-content>
            <v-list-item-subtitle>
              出向先
              <v-btn @click="changeSeconded" x-small color="primary" outlined class="ml-3" v-bind:class="{ 'mobile-button': isMobile }">変更</v-btn>
            </v-list-item-subtitle>
            <v-list-item-title>{{ this.userviewInfo.seconded_name ? this.userviewInfo.seconded_name : '出向していない' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              メールアドレス
              <v-btn @click="changeMail" x-small color="primary" outlined class="ml-3" v-bind:class="{ 'mobile-button': isMobile }">変更</v-btn>
            </v-list-item-subtitle>
            <v-list-item-title v-if="this.userviewInfo.email">
              {{emailPre}}<span style="font-size: 0.5rem;">●●●●●</span>{{emailDomain}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!this.isMobileApp">
          <v-list-item-content>
            <v-btn @click="signOut" color="primary">
              ログアウト
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { Auth } from 'aws-amplify'
import Theme from '../../utils/Theme'

export default {
  name: 'user',
  props: ['userviewInfo'],
  mixins: [Theme],
  data () {
    return {
      menu: false,
      isMobileApp: false
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    },
    emailPre () {
      return this.userviewInfo.email.substr(0, 2)
    },
    emailDomain () {
      return this.userviewInfo.email.substr(this.userviewInfo.email.indexOf('@'))
    }
  },
  async mounted () {
    if (!this.getCampaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isMobileApp = this.$store.getters.getIsMobileApp
  },
  methods: {
    changeSeconded () {
      this.$refs.userMenu.isActive = false
      this.$router.push('/seconded')
    },
    changeMail () {
      this.$refs.userMenu.isActive = false
      this.$router.push('/email')
    },
    signOut () {
      try {
        Auth.signOut()
          .then(() => {
            this.$vuetify.theme.themes.light = this.$_getTheme(false)
            this.$store.dispatch('signOut')
            this.$router.push('/login')
          })
          .catch((e) => {
            this.$emit('errorHandling', 'サインアウトに失敗しました。' + e.errors[0].message)
            this.$log.debug(e)
          })
      } catch (e) {
        this.$emit('errorHandling', 'サインアウトに失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.btn-pc-width {
  width: 120px !important;
}
.mobile-button {
  margin-bottom: 2px;
}
</style>
